export default __webpack_public_path__ + "static/polymermould-e12122a4494a225ee81cf1ebcaee1e34.png";